import { useTranslation } from 'react-i18next';
import Header from '../offer-package/header';
import { INotificationService, NotificationService } from '../services';
import Overlay from '../ui/overlay';
import { StyledLink } from '../ui';
import { Helmet } from 'react-helmet-async'; // Recommended library
import LanguageSwitch from './language-switch';

const notificationService: INotificationService = new NotificationService();

export function Finish() {
  const { t, i18n } = useTranslation('anfrage-sitaram');

  return (
    <div>
      <Overlay service={notificationService}></Overlay>

      <Helmet htmlAttributes={{ lang: i18n.language }} />

      <Header actions={<LanguageSwitch></LanguageSwitch>}></Header>

      <div className="container mt-6 space-y-4 text-center">
        <h1 className="font-serif text-2xl font-bold">{t('finish.title')}</h1>

        <p>{t('finish.description')}</p>

        <StyledLink design="primary" href="https://www.mandira-ayurveda.at">
          {t('finish.action')}
        </StyledLink>

        <div className="flex justify-center items-center">
          <div id="hotjar-fb-selector"></div>
        </div>
      </div>
    </div>
  );
}

export default Finish;
